import React, { useState } from "react";
import Card from "../../cards/Card";
import { Modal } from "../../modal/Modal";
import { ReactComponent as Cancel } from "../../../../Assets/Image/svg/cancel.svg";

const Uploaded = ({ close, show }) => {
  return (
    <div>
      {show && (
        <Card>
          <Modal show={show}>
            <div className=" pt-3 pb-8 flex flex-col justify-center items-center">
              <Cancel
                onClick={() => close(false)}
                className=" cursor-pointer absolute right-5 top-6"
              />
              <div className=" mx-[11.6rem] w-full">
                <h5 className=" mb-20 font-bold text-[2rem] text-purple-dark">
                  فایل‌های آپلود شده
                </h5>
                <ul className="w-full">
                  {files.map((file) => (
                    <li className="flex justify-between border-b-2 border-purple p-2 w-full text-[1.8rem]">
                      <span>{file.name}</span>
                      <Cancel />
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Modal>
        </Card>
      )}
    </div>
  );
};

export default Uploaded;

const files = [{ name: "تیزر.mp4" }, { name: "پاورپوینت ارائه.pdf" }];
